import React from 'react'

function Googlemap() {
  return (
    <div>
        <div className="album py-1">
                <div className="container">
                    <div className="row">
                    <iframe className="iframe-fluid mb-2"  height="140" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" id="gmap_canvas" src="https://maps.google.com/maps?width=520&amp;height=400&amp;hl=en&amp;q=Vila's%20Club%20Resort,%20Raghunath%20Tala,%20PATHSALA,%20RAGHUNATHTALA,%20Raninagar,%20Gora%20Bazar,%20Chaltia,%20Berhampore,%20West%20Bengal%20742407%20+(Vila's%20Club%20Resort,%20Raghunath%20Tala,%20PATHSALA,%20RAGHUNATHTALA,%20Raninagar,%20Gora%20Bazar,%20Chaltia,%20Berhampore,%20West%20Bengal%20742407)&amp;t=&amp;z=12&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"></iframe>
                    </div>
                </div>
            </div>
    </div>
  )
}

export default Googlemap